import {ServiceTemplateGeneric} from "./ServiceTemplateGeneric";

export class ServiceTemplateDocument extends ServiceTemplateGeneric{

    constructor(organizationId,data) {
        super(organizationId,data,"serviceDocumentList","serviceDocumentId");
    }
}
